import SidesheetHeader from "components/Dashboard/DoctorDashboard/views/one-one-sessions/components/layout/components/calendar-sidebar/components/sidesheet-header/SidesheetHeader";
import LazyImage from "components/lazy-image";
import { PUBLIC_ASSETS } from "constants/publicAssets";
import messages from "messages";
import { useDispatch, useSelector } from "react-redux";
import {
  closeSidesheet,
  selectFocusedGcalEvent,
} from "store/calendarSidebarSlice";
import { PRO_CALENDAR_ANALYTICS_PAGE_NAME, track } from "utils/amplitude";
import getClasses from "utils/getClasses";
import TimeslotTitle from "../../../calendar-view/components/scrollable-calendar-view/components/timeslot-title/TimeslotTitle";
import BlockedIntervalTitleAndDates from "../blocked-interval-title-and-dates/BlockedIntervalTitleAndDates";
import styles from "./GCalEventDetails.module.scss";

const AMPLITUDE_COMPONENT_NAME = "gcal-event-details";

const GCalEventDetails = () => {
  const dispatch = useDispatch();

  const focusedGCalEvent = useSelector(selectFocusedGcalEvent);

  if (!focusedGCalEvent) {
    return null;
  }

  return (
    <div className={styles["container"]}>
      <SidesheetHeader
        title={
          <>
            <span className={styles["icon"]}>
              <LazyImage src={PUBLIC_ASSETS.gcalIcon} width={24} height={24} />
            </span>
            <TimeslotTitle className={styles["icon-label"]}>
              {messages.googleCalendar}
            </TimeslotTitle>
          </>
        }
        onClose={() => {
          track(
            PRO_CALENDAR_ANALYTICS_PAGE_NAME,
            [AMPLITUDE_COMPONENT_NAME, "close-button"],
            "click",
          );
          dispatch(closeSidesheet());
        }}
        className={getClasses(styles["title"])}
      />

      <div className={styles["body"]}>
        <BlockedIntervalTitleAndDates blockedInterval={focusedGCalEvent} />
        <div className={styles["reschedule-info"]}>
          {messages.gcalEventInfo}
        </div>
      </div>
    </div>
  );
};

export default GCalEventDetails;
